import { Toggle } from 'samsmu-ui-kit'

export const GlobalState = {
    waitingInternetConnection: new Toggle(false),
    waitingFirstState: new Toggle(true)
}
